import React from 'react';
import { ServerConfig } from 'config';
import PaginatedList from '../../components/PaginatedList/PaginatedList';

const TenantEcoSacks = () => {
	const non_editable_fields = [
		['code', 'ID'],
		['customer_id', 'Customer ID'],
		['state', 'State'],
		['created', 'Created'],
		['last_updated', 'Last Updated'],
		['stickercode', 'Sticker Code'],
	];

	const editable_fields = [
		['new_state', 'State', 'new_state'],
		['id_site_receiving', 'Receiving Site', 'tenant_site_id'],
		['id_site_processing', 'Processing Site', 'tenant_site_id'],
	];

	const view_fields = [
		['','Customer','header'],
		['customer_id', 'Customer ID'],
		['customer.first_name', 'Customer First Name'],
		['customer.last_name', 'Customer Last Name'],
		['customer.email', 'Customer Email'],
		['customer.phone_number', 'Customer Phone'],
		['','Ecosack','break'],
		['code', 'Ecosack ID'],
		['stickercode', 'Sticker Code'],
		['state', 'Current State', 'ecosackState'],
		['created', 'Created', 'timestamp'],
		['lifecycle.at_user', 'Assigned To Customer', 'timestamp'],
		['lifecycle.picked_up', 'Received At Tenant Site', 'timestamp'],
		['lifecycle.processed', 'Processed by Tenant', 'timestamp'],
		['last_updated', 'Last Updated', 'timestamp'],
		['lifecycle.picked_up', 'Received', 'hours_ago'],
		['','Assigning Tenant','break'],
		['id_tenant', 'Assigning Tenant ID'],
		['business_name', 'Assigning Tenant Name'],
		['','Receiving Location','break'],
		['id_tenant_receiving', 'Receiving Tenant ID'],
		['name_tenant_receiving', 'Receiving Tenant Name'],
		['id_site_receiving', 'Receiving Site ID'],
		['receiving_tenant.receiving_site.name', 'Site Name'],
		['receiving_tenant.receiving_site.street', 'Site Street'],
		['receiving_tenant.receiving_site.city', 'Site City'],
		['receiving_tenant.receiving_site.state', 'Site State'],
		['receiving_tenant.receiving_site.zip', 'Site Zip'],
		['receiving_tenant.receiving_ecocontrol_id', 'EcoControl Machine ID'],
		['','Processing Location','break'],
		['id_tenant_processing', 'Processing Tenant ID'],
		['name_tenant_processing', 'Processing Tenant Name'],
		['id_site_processing', 'Processing Site ID'],
		['processing_tenant.processing_site.name', 'Site Name'],
		['processing_tenant.processing_site.street', 'Site Street'],
		['processing_tenant.processing_site.city', 'Site City'],
		['processing_tenant.processing_site.state', 'Site State'],
		['processing_tenant.processing_site.zip', 'Site Zip'],
	];

	return (
		<>
			<PaginatedList
				list_get_url={`${ServerConfig.SERVER_URL}/trackingcode/tenant_ecosacks/`}
				detail_get_url={`${ServerConfig.SERVER_URL}/trackingcode/`} // GET /trackingcode/:code (id must equal code)
				detail_put_url={`${ServerConfig.SERVER_URL}/trackingcode/`} // only works if PUT /trackingcode/:code exists
				view_request={(row) => `${ServerConfig.SERVER_URL}/trackingcode/${row.code}`}
				column_names={[
					'code',
					'customer_id',
					'state',
					'created',
					'last_updated',
					'lifecycle.picked_up',
				]}
				header_names={['ID', 'Customer ID', 'State', 'Created', 'Last Updated', 'Received']}
				optional_column_names={['stickercode']}
				optional_header_names={['Sticker Code']}
				view_fields={view_fields}
				editable_fields={editable_fields}
				non_editable_fields={non_editable_fields}
				info_banner_items={[
				<>Select <b>"Dropped Off"</b> or <b>"Processed"</b> for State to enable the tenant and site fields.</>,
				<>Select a <b>Receiving Tenant</b> to enable the site fields.</>,
				]}
			/>
		</>
	);
};

export default TenantEcoSacks;
